import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';
import { api } from '../../config';

export const putSessionInProgress = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
    try {
      const url = `/v1/sessions/${params.sessionSid}/inProgress`;
      const headers = {
        token: params.token,
      };
      const response = await api.post(url, headers);
      return response.data;
    } catch (error) {
      console.log('Error starting recording!', { error });
      throw new ApiError();
    }
  }
};
